import { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'

export const ConfirmDialog = ({
	open,
	onOpenChange,
	title,
	description,
	confirmLabel = 'Подтвердить',
	cancelLabel = 'Отмена',
	onConfirm,
	destructive = false,
	isPending = false,
	children,
}: {
	open: boolean
	onOpenChange: (open: boolean) => void
	title: string
	description: string
	confirmLabel?: string
	cancelLabel?: string
	onConfirm: () => void | Promise<void>
	destructive?: boolean
	isPending?: boolean
	children?: ReactNode
}) => (
	<Dialog open={open} onOpenChange={onOpenChange}>
		<DialogContent>
			<DialogHeader>
				<DialogTitle>{title}</DialogTitle>
				<DialogDescription>{description}</DialogDescription>
			</DialogHeader>
			{children}
			<DialogFooter>
				<Button variant='outline' onClick={() => onOpenChange(false)} disabled={isPending}>
					{cancelLabel}
				</Button>
				<Button
					variant={destructive ? 'destructive' : 'default'}
					onClick={() => void onConfirm()}
					disabled={isPending}>
					{isPending ? 'Выполняется…' : confirmLabel}
				</Button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
)
